import React from "react";

export default class GameButtonWithText extends React.Component{

    render() {
        let colorActive = `linear-gradient(180deg, ${this.props.colorStart ?? "#56CCF2"} 0%,${this.props.colorEnd ?? "#2D9CDB"} 100%)`;
        let colorInactive = "#DADADA";
        let style = {
            width: this.props.width ?? 20,
            height: this.props.height ?? 20,
            borderRadius: "3px",
            background: !this.props.disabled ? colorActive : colorInactive,
            textAlign: 'center'
        }
        let textStyle = {
            margin: "auto",
            fontWeight: this.props.fontWeight ?? "bold",
            color: "black",
            fontSize: `${this.props.fontSize ?? 14}px`,
            lineHeight: `${this.props.fontSize ?? 14}px`,
            textTransform: "uppercase",
            textShadow: "0px 1px 1px rgba(0, 0, 0, 0.5)"
        }
        return <button title={this.props.tooltip} className={this.props.isHideEvents ? "" : "game-btn"} style={{...this.props.style, ...style}} onClick={this.props.onClick} disabled={this.props.disabled}>
            <div style={textStyle}>{this.props.title}</div>
        </button>
    }
}
